import React from "react";
import { graphql } from "gatsby";
import GraphQLErrorList from "../components/graphql-error-list";
import Seo from "../components/seo";
import Layout from "../containers/layout";
import PageHeader from "../components/page-header";
import ApplicationsLandingMain from "../components/applications-landing-main";
import Cta from "../components/cta";

const ApplicationsLandingPage: React.FC<PageProps<any>> = ({ data, errors }) => {
  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const applicationsLanding = data?.applicationsLanding;
  const applications = data?.applications?.edges;

  return (
    <Layout>
      <PageHeader title={applicationsLanding?.title} copy={applicationsLanding?._rawSubline} bigTitle={true} />
      <ApplicationsLandingMain applications={applications} />
      <Cta {...applicationsLanding?.cta} />
    </Layout>
  );
};

export default ApplicationsLandingPage;

export const Head: React.FC<{ data: any }> = ({ data }) => {
  const applicationsLanding = data?.applicationsLanding;

  return (
    <Seo
      title={applicationsLanding?.title}
      description={applicationsLanding?.seo?.description}
      image={applicationsLanding?.seo?.thumbnail}
    />
  )
}

export const query = graphql`
  query ApplicationsLandingPageQuery {
    applicationsLanding: sanityApplicationsLanding {
      title
      _rawSubline
      cta {
        title
        subtitle
        button {
          blank
          text
          url
        }
        image {
          desktop {
            asset {
              _id
            }
            alt
          }
          mobile {
            asset {
              _id
            }
          }
        }
        imageOverlay
      }
      seo {
        description
        thumbnail {
          asset {
            _id
          }
          alt
        }
      }
    }

    applications: allSanityApplication(sort: { orderRank: ASC }) {
      edges {
        node {
          id
          title
          slug {
            current
          }
          lp {
            image {
              asset {
                _id
              }
              alt
            }
            _rawExcerpt
          }
        }
      }
    }
  }
`;
